/* ==========================================================================
   HOLY LAND MARKET — HOMEPAGE JAVASCRIPT
   Handles: Hero Slideshow, Tabbed Collections, Smooth interactions
   ========================================================================== */

(function() {
  'use strict';

  if (window.__hlHomepageLoaded) {
    return;
  }
  window.__hlHomepageLoaded = true;

  /* ---------- HERO SLIDESHOW ---------- */
  document.querySelectorAll('[data-hl-hero]').forEach(function(hero) {
    var track = hero.querySelector('[data-hl-track]');
    var slides = hero.querySelectorAll('[data-hl-slide]');
    var dots = hero.querySelectorAll('[data-hl-dot]');
    var prevBtn = hero.querySelector('[data-hl-prev]');
    var nextBtn = hero.querySelector('[data-hl-next]');
    var autoplaySpeed = parseInt(hero.getAttribute('data-hl-autoplay') || '4000', 10);
    var current = 0;
    var total = slides.length;
    var autoTimer = null;

    if (total <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (autoplaySpeed > 0) {
        autoTimer = setInterval(next, autoplaySpeed);
      }
    }
    function stopAutoplay() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { next(); startAutoplay(); });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); startAutoplay(); });
    });

    // Swipe support
    var touchStartX = 0;
    var touchEndX = 0;
    hero.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    hero.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next(); else prev();
        startAutoplay();
      }
    }, { passive: true });

    // Pause on hover
    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });


  /* ---------- TABBED COLLECTIONS ---------- */

  function hlFormatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function hlBuildProductCard(product, collectionHandle, collectionTitle) {
    var img = product.images && product.images[0];
    var imageHtml = '';
    if (img) {
      var base = img.src.split('?')[0];
      var srcset = base + '?width=300 300w, ' + base + '?width=400 400w, ' + base + '?width=600 600w';
      imageHtml =
        '<img class="hl-lazy-loaded-image" src="' + base + '?width=400" srcset="' + srcset + '" ' +
        'sizes="(max-width: 768px) 50vw, 25vw" alt="' + (img.alt ? img.alt.replace(/"/g, '&quot;') : product.title.replace(/"/g, '&quot;')) + '" ' +
        'loading="lazy" width="' + img.width + '" height="' + img.height + '">';
    } else {
      imageHtml = '<div class="hl-placeholder-svg"></div>';
    }

    var available = product.variants.some(function(v) { return v.available; });
    var soldOutBadge = available ? '' : '<div class="badge-sold-out">Sold Out</div>';
    var notifyBlock = available ? '' :
      '<div class="ecomsend-bis-block" data-product-id="' + product.id + '"></div>' +
      '<span class="hl-notify-btn">Notify Me!</span>';

    var firstVariant = product.variants[0];
    var priceHtml = hlFormatMoney(firstVariant.price * 100);
    var compareHtml = '';
    if (firstVariant.compare_at_price && parseFloat(firstVariant.compare_at_price) > parseFloat(firstVariant.price)) {
      compareHtml = '<span class="hl-product-card__price-compare">' + hlFormatMoney(firstVariant.compare_at_price * 100) + '</span>';
    }

    var variantPills = '';
    if (product.variants.length > 1) {
      var pills = product.variants.map(function(v) {
        return '<span class="vc-pill-home" data-vc-url="/products/' + product.handle + '?variant=' + v.id + '">' + v.title + '</span>';
      }).join('');
      variantPills =
        '<div class="vc-carousel-home" data-vc-current="0">' +
        '<button class="vc-arrow-home vc-prev-home" type="button" aria-label="Previous size">&lsaquo;</button>' +
        '<div class="vc-window-home"><div class="vc-track-home">' + pills + '</div></div>' +
        '<button class="vc-arrow-home vc-next-home" type="button" aria-label="Next size">&rsaquo;</button>' +
        '</div>';
    }

    var a = document.createElement('a');
    a.href = '/products/' + product.handle;
    a.className = 'hl-product-card';
    a.setAttribute('data-collection-url', '/collections/' + collectionHandle);
    a.setAttribute('data-collection-title', collectionTitle);
    a.addEventListener('mousedown', hlStoreBreadcrumb);
    a.addEventListener('touchstart', hlStoreBreadcrumb, { passive: true });
    a.innerHTML =
      '<div class="hl-product-card__image">' + imageHtml + soldOutBadge + '</div>' +
      '<div class="hl-product-card__info">' +
      '<h3 class="hl-product-card__title">' + product.title.replace(/</g, '&lt;') + '</h3>' +
      '<div class="hl-product-card__price">' + priceHtml + compareHtml + '</div>' +
      variantPills + notifyBlock +
      '</div>';
    return a;
  }

  function hlStoreBreadcrumb() {
    try {
      sessionStorage.setItem('hl_breadcrumb_collection', JSON.stringify({
        url: this.dataset.collectionUrl,
        title: this.dataset.collectionTitle,
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function hlLoadTabPanel(panel) {
    var handle = panel.getAttribute('data-hl-lazy-collection');
    var title = panel.getAttribute('data-hl-lazy-title') || '';
    var limit = parseInt(panel.getAttribute('data-hl-lazy-limit') || '8', 10);
    if (!handle || panel.getAttribute('data-hl-lazy-loaded') === 'true') return;
    panel.setAttribute('data-hl-lazy-loaded', 'true');

    fetch('/collections/' + handle + '/products.json?limit=' + limit)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var products = data.products;
        if (!products || !products.length) return;
        var grid = panel.querySelector('.hl-product-grid');
        if (!grid) return;
        var frag = document.createDocumentFragment();
        products.slice(0, limit).forEach(function(product) {
          frag.appendChild(hlBuildProductCard(product, handle, title));
        });
        grid.innerHTML = '';
        grid.appendChild(frag);
        // Best-effort nudge for apps (e.g. back-in-stock) that listen for
        // section-load events to rescan the DOM for their own blocks.
        document.dispatchEvent(new Event('shopify:section:load'));
      })
      .catch(function() {
        panel.setAttribute('data-hl-lazy-loaded', 'false');
      });
  }

  document.querySelectorAll('[data-hl-tabs]').forEach(function(section) {
    var tabs = section.querySelectorAll('[data-hl-tab]');
    var panels = section.querySelectorAll('[data-hl-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-hl-tab');

        tabs.forEach(function(t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        panels.forEach(function(p) {
          if (p.getAttribute('data-hl-panel') === target) {
            p.classList.add('is-active');
            hlLoadTabPanel(p);
          } else {
            p.classList.remove('is-active');
          }
        });
      });
    });

    // Keyboard accessibility
    tabs.forEach(function(tab, index) {
      tab.addEventListener('keydown', function(e) {
        var nextIndex;
        if (e.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        } else if (e.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        }
      });
    });
  });


  /* ---------- INTERSECTION OBSERVER (fade-in on scroll) ---------- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hl-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.hl-animate').forEach(function(el) {
      observer.observe(el);
    });
  }

})();